import { calculateDatesRange } from '@wolfdanepug/common-react'
import { noImage, profileColors } from './constants'
import moment from 'moment'

export const variableToString = (varObj: any) => Object.keys(varObj)[0]
/**
 * @deprectaed use @/components/Form/fieldName instead
 */
export const fieldName = (name: string, context?: string, index?: number, suffix: string = '') => {
	return context
		? index
			? `${context}[${index}][${name}]${suffix}`
			: `${context}[${name}]${suffix}`
		: name
}
export const createArray = (length: number = 0) => Array.from({ length: length }, (_, i) => i + 1)

export const isObject = (item: any) => item && typeof item === 'object' && !Array.isArray(item)
export const deepMerge = (target: any, source: any) => {
	const output = { ...target }

	if (isObject(target) && isObject(source)) {
		Object.keys(source).forEach((key) => {
			if (isObject(source[key])) {
				if (!(key in target)) Object.assign(output, { [key]: source[key] })
				else output[key] = deepMerge(target[key], source[key])
			} else {
				Object.assign(output, { [key]: source[key] })
			}
		})
	}
	return output
}

export const filterEnabledItems = (items: any) => items.filter((item: any) => item.enabled)

export const convertToEnglishWordList = (list: string[]) => {
	if (!list || list.length === 0) return ''
	if (list.length === 1) return list[0]
	if (list.length === 2) return list.join(' and ')
	return list.slice(0, -1).join(', ') + ', and ' + list.slice(-1)
}

export const buildLink = (...segments: string[]) => {
	return '/' + segments.filter(Boolean).join('/')
}

export const getUpcomingBillingDate = (initialStartDate: number = Date.now()) => {
	const today = Date.now()
	if (initialStartDate > today) {
		return initialStartDate
	}
	return calculateDatesRange({
		rangeStart: initialStartDate,
		rangeEnd: +moment(initialStartDate).add(16, 'days')
	})
		.filter((date: any) => date >= today)
		.shift()
}

/**
 * Get no image by index
 * @param {number} index
 * @param {number} operand
 * @returns {string} image path
 */
export const getNoImage = (index: number, operand = 3): string => {
	return noImage[index % operand] || noImage[0]
}

/**
 * Get profile color by index
 * @param {number} index
 * @param {number} operand
 * @returns {string} color
 */
export const getProfileColor = (index: number, operand = profileColors.length - 1): string => {
	return profileColors[index % operand] || profileColors[0]
}
